<template>
	<div id="members-avatar-list">
		<div
			class="member-avatar-container"
            v-for="(member, index) in assignedMembers"
            :key="index"
            :class="{ hide: index >= maxAvatars }"
        >
            <img v-if="index < maxAvatars" :src="getGravatar(member.email)" :name="'member' + index" class="member-avatar" />
            <tippy :to="'member'+ index">
                {{ name(member) }}
                <span class="color-warning ml-1" v-if="isUserSuspended(member)">(suspended)</span>
            </tippy>
        </div>
        <div v-if="assignedMembers.length > maxAvatars" class="member-avatar-container --more">
            <span class="member-avatar">+{{ assignedMembers.length - maxAvatars }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import AvatarMixins from "@/mixins/Avatar";

export default {
	mixins: [AvatarMixins],
	data() {
		return {
			maxAvatars: 4,
		};
	},

	computed: {
		...mapState("Projects", ["project"]),
		...mapGetters("Organizations", ["memberAccountByUserId"]),
		assignedMembers() {
			if (!this.project.users) return [];
			return this.project.users.filter(user => {
				return this.memberAccountByUserId(user.id)
			});
		},
	},
	methods: {
		isUserAssigned(id) {
			if (!this.project.users) return false;
			return this.project.users.some(user => user.id == id);
		},

        name(user) {
		    let name = user.name;
		    if (this.$store.state.User.user.id == user.id) name += " (You)";
		    return name;
        },

		isUserSuspended(user) {
         	if (this.$store.getters['Organizations/accountByUserId'](user.id)?.suspended_at) return true;
            else if (this.$store.getters['Organizations/memberAccountByUserId'](user.id)?.pivot.suspended_at) return true;
		}
	},
};
</script>

<style lang="scss">
#members-avatar-list {
	display: flex;
	.member-avatar-container {
		margin-left: -5px;
		position: relative;
		.member-avatar {
			border: 1px solid var(--primary);
			border-radius: 25px;
			width: 30px;
			height: 30px;
			background: white;
		}

		&.--more {
			> .member-avatar {
				display: flex;
				justify-content: center;
				align-items: center;
				font-weight: bold;
				color: var(--font-default-color);
				background: #363636;
				font-size: 1rem;
				// border-color: #363636;
			}
		}
	}
}
</style>
